import { Timestamp } from '@griply/types';

type CompletedCalendarTask = {
  parentIds?: string[] | null;
  archivedAt?: Timestamp | null;
};

// Subtasks and archived tasks never paint on the calendar grids.
export const filterCompletedCalendarTasks = <T extends CompletedCalendarTask>(
  tasks: T[],
): T[] => tasks.filter((task) => !task.parentIds?.length && !task.archivedAt);
